import { Box, FormControl, FormControlLabel, FormLabel, Grid2, Input, Radio, RadioGroup } from "@mui/material";
import { Log, useTranslation } from "@fanfanlo";
import { NodeAction, nodeActions, NodeActionKeys } from "./A11yNode";

const fileLog = new Log(false, 'NodeActionUI_f');
fileLog.pause = true;
fileLog.childrenPaused = true;

export interface INodeActionUIParams{
    nodeAction:NodeAction
    setNodeAction:(nodeAction:NodeAction)=>void
    text:string
    setText:(text:string)=>void
}
export function NodeActionUI({nodeAction, setNodeAction, text, setText}: INodeActionUIParams) {
    const uiLog = fileLog.sub(false, 'NodeActionUI_ui');
    uiLog.pause = true;

    const { t } = useTranslation("droid-project-v2-interface/a11y/content")
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fnLog = uiLog.sub(false, 'handleChange_fn');
        fnLog.log('handleChange, value=', event.target.value);
        setNodeAction(nodeActions[event.target.value])
      };

    return (
        <>
            <Box sx={{ width: "100%" }}>

                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">{t("NodeActionUI.title")}</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={nodeAction.value}
                        name="radio-buttons-group"
                        onChange={handleChange}
                    >
                        <FormControlLabel value={NodeActionKeys.click} control={<Radio />} label={t("NodeActionUI.click")} />
                        <FormControlLabel value={NodeActionKeys.longClick} control={<Radio />} label={t("NodeActionUI.longClick")} />
                        <Grid2 direction="row" spacing={2} container>
                            <Grid2 size="auto">
                                <FormControlLabel value={NodeActionKeys.setText} control={<Radio />} label={t("NodeActionUI.setText")} />
                            </Grid2>
                            <Grid2 size="grow">
                                <Input value={text} onChange={(e) => setText(e.target.value)} />
                            </Grid2>
                        </Grid2>
                        <FormControlLabel value={NodeActionKeys.tryClick} control={<Radio />} label={t("NodeActionUI.tryClick")} />
                        <FormControlLabel value={NodeActionKeys.globalClick} control={<Radio />} label={t("NodeActionUI.globalClick")} />
                    </RadioGroup>
                </FormControl>
            </Box>
        </>
    )
}
